<app-header (locale)="onLocaleChange($event)"></app-header>
<div class="app-body pt-1 mt-1">
  <main class="main d-flex align-items-center">
    <div
      class="container pt-0"
      [ngClass]="{
        'pt-1':
          (invalidCredentials$ | async) ||
          ((userVerified || partnerVerified) &&
            !(invalidCredentials$ | async)) ||
          (userPasswordReset && !(invalidCredentials$ | async)) ||
          (emailUpdated && !(invalidCredentials$ | async)) ||
          (userInvited && !(invalidCredentials$ | async)),
      }"
    >
      <div class="alert-wrapper w-100 justify-content-center">
        <div class="container px-md-5 text-center">
          <div class="d-flex flex-row alert-flex-row w-100 px-2 px-sm-5">
            <div class="d-flex w-100">
              <div
                role="alert"
                data-testid="alert-error-message"
                class="alert w-100 alert-danger"
                *ngIf="invalidCredentials$ | async"
              >
                <strong>{{ 'admin.alerts.headerError' | translate }}</strong>
                {{ 'admin.alerts.invalidCredentials' | translate }}
              </div>
              <div
                role="alert"
                data-testid="alert-error-message"
                class="alert w-100 alert-danger"
                *ngIf="socialAccountLoginFailed$ | async"
              >
                <strong>{{ 'admin.alerts.headerError' | translate }}</strong>
                {{ 'admin.alerts.socialAccountLoginFailed' | translate }}
              </div>
              <div
                role="alert"
                data-testid="alert-success-message"
                class="alert w-100 alert-success"
                *ngIf="
                  (userVerified || partnerVerified) &&
                  !(invalidCredentials$ | async)
                "
              >
                <strong>{{ 'admin.alerts.headerSuccess' | translate }}</strong>
                {{ 'admin.alerts.accountActivated' | translate }}
              </div>
              <div
                role="alert"
                data-testid="alert-success-message"
                class="alert w-100 alert-success"
                *ngIf="userPasswordReset && !(invalidCredentials$ | async)"
              >
                <strong>{{ 'admin.alerts.headerSuccess' | translate }}</strong>
                {{ 'admin.alerts.passwordChanged' | translate }}
              </div>
              <div
                role="alert"
                data-testid="alert-success-message"
                class="alert w-100 alert-success"
                *ngIf="emailUpdated && !(invalidCredentials$ | async)"
              >
                <strong>{{ 'admin.alerts.headerSuccess' | translate }}</strong>
                {{ 'admin.alerts.emailChanged' | translate }}
              </div>
              <div
                role="alert"
                data-testid="alert-success-message"
                class="alert w-100 alert-success"
                *ngIf="userInvited && !(invalidCredentials$ | async)"
              >
                <strong>{{ 'admin.alerts.headerSuccess' | translate }}</strong>
                {{
                  'admin.alerts.userInvitationSuccessfull'
                    | translate: storeNameTraslationToken
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div class="card mx-auto">
          <div
            class="card-body card_width px-4 px-md-5 py-3 py-md-5 shadow-no-mobile shadow mx-auto"
            (keyup.enter)="loginAction()"
          >
            <div class="card-content">
              <h1
                class="primary-brand-color mb-3"
                data-testid="login-page-title"
              >
                {{ 'admin.global.login' | translate }}
              </h1>
              <ng-container *ngIf="socialLoginEnabled">
                <div *ngIf="!isMobile()">
                  <iframe
                    id="user-login"
                    [src]="userLoginSrc"
                    class="login-iframe"
                    frameBorder="0"
                    scrolling="no"
                  ></iframe>
                </div>

                <app-user-login
                  *ngIf="isMobile()"
                  class="user-login w-100"
                  authType="adminlogin"
                ></app-user-login>

                <div>
                  <div class="or-separator">
                    <span>OR</span>
                  </div>
                </div>
              </ng-container>

              <form [formGroup]="loginForm" class="pb-0">
                <div class="row">
                  <div
                    class="col mb-1"
                    [ngClass]="{
                      'mb-3':
                        username.touched &&
                        username.errors &&
                        username.errors.required,
                    }"
                  >
                    <app-mat-input
                      [control]="$any(username)"
                      label="admin.global.email"
                      inputId="login-email-field"
                      fieldClass="mat-form-field-custom"
                      errorSuffix="."
                      [errors]="{ required: 'admin.global.field.required' }"
                    ></app-mat-input>
                  </div>
                  <div class="w-100"></div>
                  <div
                    class="col"
                    [ngClass]="{
                      'mb-3':
                        (password.touched &&
                          password.errors &&
                          password.errors.required) ||
                        (password.touched &&
                          password.errors &&
                          password.errors.minlength),
                    }"
                  >
                    <app-mat-input
                      [control]="$any(password)"
                      label="admin.global.password"
                      inputId="login-password-field"
                      fieldClass="mat-form-field-custom"
                      [passwordToggle]="true"
                      suffixClass="pwdicon-top"
                      errorSuffix="."
                      [errors]="{
                        required: 'admin.global.field.required',
                        minlength: 'admin.global.field.minLength',
                        maxlength: 'admin.global.field.maxLength',
                      }"
                    ></app-mat-input>
                  </div>
                </div>
                <div class="d-flex flex-row mb-2 mb-xs-0 justify-content-end">
                  <app-button
                    type="button"
                    variant="none"
                    class="forgetPassword"
                    classes="btn-link px-0"
                    dataTestid="login-forgot-password-link"
                    (click)="goToForgotPassword()"
                  >
                    {{ 'admin.login.forgetPassword' | translate }}
                  </app-button>
                </div>
                <div class="d-flex flex-row justify-content-center">
                  <app-button
                    type="button"
                    variant="primary"
                    class="w-100"
                    classes="w-100 py-3 font-weight-bold"
                    id="login-submit-button"
                    (click)="loginAction()"
                  >
                    {{ 'admin.global.login' | translate }}
                  </app-button>
                </div>

                <div class="pt-2 d-flex flex-row" *ngIf="!isIOSApp">
                  <div class="d-flex btn-pre-text text-dark-blue">
                    {{ 'admin.login.noAccount' | translate }}
                  </div>
                  <app-button
                    type="button"
                    variant="none"
                    classes="btn-link d-flex px-0"
                    dataTestid="login-signup-button"
                    (click)="goToRegistration()"
                  >
                    {{ 'admin.login.signUp' | translate }}
                  </app-button>
                </div>

                <app-terms-privacy-platform
                  [message]="'admin.global.byContinuingYouAgree' | translate"
                ></app-terms-privacy-platform>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
